var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    {
      staticClass: "floor-plan-item-list",
      attrs: { flat: "", "data-testid": _vm.type + "-list" },
    },
    [
      _vm.hasUnplacedItems
        ? _c(
            "v-alert",
            {
              staticClass: "mx-3 mb-0 text-caption",
              attrs: { dense: "", type: "info", text: "" },
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(_vm.$mpt(_vm.$t(_vm.type + ".drag_hint"))) +
                  "\n  "
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-card-text",
        { staticClass: "floor-plan-item-list__content pa-0" },
        [
          _c(
            "v-list",
            { key: _vm.listKey, attrs: { dense: "" } },
            [
              _vm._l(_vm.placeableItems, function (item) {
                return _c(
                  "v-tooltip",
                  {
                    key: item.id,
                    attrs: {
                      disabled: !item.isPlacedOnOtherFloorPlan,
                      bottom: "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function (ref) {
                            var on = ref.on
                            var attrs = ref.attrs
                            return [
                              _c(
                                "v-list-item",
                                _vm._g(
                                  _vm._b(
                                    {
                                      staticClass: "floor-plan-item-list__item",
                                      class: _vm.getItemClass(item),
                                      attrs: {
                                        draggable:
                                          !item.isPlacedOnOtherFloorPlan,
                                        "data-testid":
                                          _vm.type + "-item-" + item.id,
                                      },
                                      on: {
                                        dragstart: function ($event) {
                                          return _vm.handleDragStart(
                                            $event,
                                            item
                                          )
                                        },
                                      },
                                    },
                                    "v-list-item",
                                    attrs,
                                    false
                                  ),
                                  on
                                ),
                                [
                                  _c(
                                    "v-list-item-icon",
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            small: "",
                                            color: _vm.getIconColor(item),
                                            "aria-label":
                                              _vm.getStatusLabel(item),
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(_vm.getIcon(item)) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _vm.typeLabel(item)
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "floor-plan-item-list__type",
                                              attrs: {
                                                "data-testid":
                                                  "item-type-label",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.typeLabel(item))
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-item-title",
                                        {
                                          staticClass:
                                            "floor-plan-item-list__name",
                                          attrs: { title: item.label },
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(item.label) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("v-list-item-subtitle", [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.$t(_vm.type + ".count", {
                                                count: item.count,
                                              })
                                            ) +
                                            "\n              "
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  item.status
                                    ? _c(
                                        "v-list-item-action",
                                        {
                                          staticClass:
                                            "floor-plan-item-list__status",
                                        },
                                        [
                                          _c("status-chip", {
                                            attrs: { status: item.status },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.isPlaced
                                    ? _c(
                                        "v-list-item-action",
                                        {
                                          staticClass:
                                            "floor-plan-item-list__remove",
                                        },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                icon: "",
                                                "x-small": "",
                                                "aria-label": _vm.$mpt(
                                                  _vm.$t(_vm.type + ".remove", {
                                                    label: item.label,
                                                  })
                                                ),
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.$emit(
                                                    "remove",
                                                    item.id
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { small: "" } },
                                                [_vm._v("mdi-close")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  },
                  [
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("placed_on_other", {
                            name: item.placedFloorPlanName,
                          })
                        )
                      ),
                    ]),
                  ]
                )
              }),
              _vm._v(" "),
              _vm.otherFloorPlanItems.length > 0
                ? [
                    _c("list-section-divider", {
                      attrs: {
                        label: _vm.$t("other_floor_plan_section"),
                        testid: "other-floor-plan-section-header",
                      },
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.otherFloorPlanItems, function (item) {
                      return _c(
                        "v-tooltip",
                        {
                          key: item.id,
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function (ref) {
                                  var on = ref.on
                                  var attrs = ref.attrs
                                  return [
                                    _c(
                                      "v-list-item",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            staticClass:
                                              "floor-plan-item-list__item",
                                            class: _vm.getItemClass(item),
                                            attrs: {
                                              draggable: false,
                                              "data-testid":
                                                "other-floor-plan-item",
                                            },
                                            on: {
                                              dragstart: function ($event) {
                                                return _vm.handleDragStart(
                                                  $event,
                                                  item
                                                )
                                              },
                                            },
                                          },
                                          "v-list-item",
                                          attrs,
                                          false
                                        ),
                                        on
                                      ),
                                      [
                                        _c(
                                          "v-list-item-icon",
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  small: "",
                                                  color: _vm.getIconColor(item),
                                                  "aria-label":
                                                    _vm.getStatusLabel(item),
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(_vm.getIcon(item)) +
                                                    "\n                "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-list-item-content",
                                          [
                                            _vm.typeLabel(item)
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "floor-plan-item-list__type",
                                                    attrs: {
                                                      "data-testid":
                                                        "item-type-label",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.typeLabel(item)
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "v-list-item-title",
                                              {
                                                staticClass:
                                                  "floor-plan-item-list__name",
                                                attrs: { title: item.label },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(item.label) +
                                                    "\n                "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("v-list-item-subtitle", [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      _vm.type + ".count",
                                                      { count: item.count }
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        item.status
                                          ? _c(
                                              "v-list-item-action",
                                              {
                                                staticClass:
                                                  "floor-plan-item-list__status",
                                              },
                                              [
                                                _c("status-chip", {
                                                  attrs: {
                                                    status: item.status,
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("placed_on_other", {
                                  name: item.placedFloorPlanName,
                                })
                              )
                            ),
                          ]),
                        ]
                      )
                    }),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }